PJQ.views.projects.ProcorePublishModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Procore-Project-Publish'),
        width: '800px',
        minWidth: '800px',
        onPublish: _.noop,
        settings: null,
        procoreProjectNumber: null
    },
    events: {
        'click .publish' : 'publish'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            settings: this.options.settings,
            isProcoreProjectNumber: this.options.procoreProjectNumber != null,
            procoreProjectNumber: this.options.procoreProjectNumber
        };
    },
    afterRender: function () {
        this.companyInput = new PJQ.inputs.Selectpicker({
            el: this.$('.procore-company'),
            isIntChoices: true,
            isDisabled: this.options.settings.companies.length === 1,
            defaultValue: this.options.settings.companies[0].id,
            onChange: _.bind(function (value) {
                let loader = new PJQ.Loader(this.$('.modal-body'));

                new PJQ.ajax.Request({
                    endpoint: '/procore/settings/' + value
                }).get().done(_.bind(function (response) {
                    if (loader != null)
                        loader.remove();
                    this.options.settings = response;
                    this.afterCompanyChanged();
                }, this)).fail(_.bind(function (xhr, err, result) {
                }, this));
            }, this)
        });

        this.$('.procore-project-name').val(PJQ.app.session.project.get('projectName'));

        this.startDateInput = new PJQ.inputs.Datepicker({
            el: this.$('.procore-est-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.app.session.project.get('startDate') ? PJQ.helpers.dateHelpers.parseDateString(PJQ.app.session.project.get('startDate'), false) : null
            }
        });

        this.completeDateInput = new PJQ.inputs.Datepicker({
            el: this.$('.procore-est-complete'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.app.session.project.get('endDate') ? PJQ.helpers.dateHelpers.parseDateString(PJQ.app.session.project.get('endDate'), false) : null
            }
        });

        new PJQ.views.projects.ProjectAttachments({
            el: this.$('.project-attachments'),
            project: PJQ.app.session.project,
            isHideDownload: true,
            isHideFiles: true,
            isHidePrivate: false,
            onChange: _.bind(function(attachments) {
                this.options.selectedAttachments = attachments;
            },this)
        });

        this.afterCompanyChanged();
    },
    afterCompanyChanged: function() {

        if (this.options.settings.companyOffices.length === 1 && this.options.settings.companyOffices[0].id === null)
            this.options.settings.companyOffices = [];

        if (this.options.settings.companyOffices.length === 0) {
            this.$('.procore-company-office').closest('div.form-group').hide();
            if (this.companyOfficeInput)
                this.companyOfficeInput.setValue(null);
        }
        else {
            this.$('.procore-company-office').closest('div.form-group').show();
            if (!this.companyOfficeInput)
            {
                this.companyOfficeInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-company-office'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.companyOffices.length === 1,
                    choices: this.options.settings.companyOffices,
                    defaultValue: this.options.settings.companyOffices[0].id
                });
            }
            else
            {
                this.companyOfficeInput.updateChoices(this.options.settings.companyOffices);
                this.companyOfficeInput.setValue(this.options.settings.companyOffices[0].id);
            }
        }

        if (this.options.settings.programs.length === 1 && this.options.settings.programs[0].id === null)
            this.options.settings.programs = [];

        if (this.options.settings.programs.length === 0) {
            this.$('.procore-project-program').closest('div.form-group').hide();
            if (this.projectProgramInput)
                this.projectProgramInput.setValue(null);
        }
        else {
            this.$('.procore-project-program').closest('div.form-group').show();
            if (!this.projectProgramInput)
            {
                this.projectProgramInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-program'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.programs.length === 1,
                    choices: this.options.settings.programs,
                    defaultValue: this.options.settings.programs[0].id
                });
            }
            else
            {
                this.projectProgramInput.updateChoices(this.options.settings.programs);
                this.projectProgramInput.setValue(this.options.settings.programs[0].id);
            }
        }

        if (this.options.settings.projectTemplates.length === 1 && this.options.settings.projectTemplates[0].id === null)
            this.options.settings.projectTemplates = [];

        if (this.options.settings.projectTemplates.length === 0) {
            this.$('.procore-project-template').closest('div.form-group').hide();
            if (this.projectTemplateInput)
                this.projectTemplateInput.setValue(null);
        }
        else {
            this.$('.procore-project-template').closest('div.form-group').show();
            if (!this.projectTemplateInput)
            {
                this.projectTemplateInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-template'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectTemplates.length === 1,
                    choices: this.options.settings.projectTemplates,
                    defaultValue: this.options.settings.projectTemplates[0].id
                });
            }
            else
            {
                this.projectTemplateInput.updateChoices(this.options.settings.projectTemplates);
                this.projectTemplateInput.setValue(this.options.settings.projectTemplates[0].id);
            }
        }

        if (this.options.settings.projectTypes.length === 1 && this.options.settings.projectTypes[0].id === null)
            this.options.settings.projectTypes = [];

        if (this.options.settings.projectTypes.length === 0) {
            this.$('.procore-project-type').closest('div.form-group').hide();
            if (this.projectTypeInput)
                this.projectTypeInput.setValue(null);
        }
        else {
            this.$('.procore-project-type').closest('div.form-group').show();
            if (!this.projectTypeInput)
            {
                this.projectTypeInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-type'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectTypes.length === 1,
                    choices: this.options.settings.projectTypes,
                    defaultValue: this.options.settings.projectTypes[0].id
                });
            }
            else
            {
                this.projectTypeInput.updateChoices(this.options.settings.projectTypes);
                this.projectTypeInput.setValue(this.options.settings.projectTypes[0].id);
            }
        }

        if (this.options.settings.projectStages.length === 1 && this.options.settings.projectStages[0].id === null)
            this.options.settings.projectStages = [];

        if (this.options.settings.projectStages.length === 0) {
            this.$('.procore-project-stage').closest('div.form-group').hide();
            if (this.projectStageInput)
                this.projectStageInput.setValue(null);
        }
        else {
            this.$('.procore-project-stage').closest('div.form-group').show();
            if (!this.projectStageInput)
            {
                this.projectStageInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-stage'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectStages.length === 1,
                    choices: this.options.settings.projectStages,
                    defaultValue: this.options.settings.projectStages[0].id
                });
            }
            else
            {
                this.projectStageInput.updateChoices(this.options.settings.projectStages);
                this.projectStageInput.setValue(this.options.settings.projectStages[0].id);
            }
        }
    },
    publish: function() {

        let projectAddress = PJQ.app.session.project.get('address1');

        if (PJQ.app.session.project.get('address2')) {

            if (projectAddress)
                projectAddress += ' ';

            projectAddress += PJQ.app.session.project.get('address2');
        }

        let office_id = 0;
        if (this.companyOfficeInput && this.companyOfficeInput.getValue())
            office_id = this.companyOfficeInput.getValue();

        let project_stage_id = 0;
        if (this.projectStageInput && this.projectStageInput.getValue())
            project_stage_id = this.projectStageInput.getValue();

        let program_id = 0;
        if (this.projectProgramInput && this.projectProgramInput.getValue())
            program_id = this.projectProgramInput.getValue();

        let project_type_id = 0;
        if (this.projectTypeInput && this.projectTypeInput.getValue())
            project_type_id = this.projectTypeInput.getValue();

        let project_template_id = 0;
        if (this.projectTemplateInput && this.projectTemplateInput.getValue())
            project_template_id = this.projectTemplateInput.getValue();

        let square_feet = 0;
        if (_.size(PJQ.helpers.formatHelpers.numbersOnly(this.$('.procore-square-feet'))) > 0) {
            square_feet = parseInt(PJQ.helpers.formatHelpers.numbersOnly(this.$('.procore-square-feet')));
        }

        let attachments = [], drawings = [];
        if (this.options.selectedAttachments) {
            attachments = _.map(_.filter(this.options.selectedAttachments.models, function(model) { return !model.get('isDrawing') }),
                function(attachment) { return attachment.get('entryId'); });
            drawings = _.map(_.filter(this.options.selectedAttachments.models, function(model) { return model.get('isDrawing') }),
                function(attachment) { return attachment.get('folderId') == 0 ? -2 : attachment.get('versionId'); });
        }

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_PROJECT_NUMBER_CUSTOM_FIELD) && _.size(attachments) == 0 && _.size(drawings) == 0) {
            PJQ.notifications.notify.errorNotify({
                message: 'Select drawings or attachments in order to Publish to Procore'
            });
            return;
        }

        let postData = {
            company_id: this.companyInput.getValue(),
            name: this.$('.procore-project-name').val().trim(),
            project_number: this.$('.procore-project-number').val().toString().trim(),
            address: projectAddress,
            city: PJQ.app.session.project.get('city').trim(),
            zip: PJQ.app.session.project.get('zip').trim(),
            state_code: PJQ.app.session.project.get('state'),
            country_code: PJQ.app.session.project.get('country'),
            description: '',
            public_notes: '',
            est_start_date: this.startDateInput.getValue() ? PJQ.helpers.dateHelpers.getDateString(this.startDateInput.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE) : '',
            est_completion_date: this.completeDateInput.getValue() ? PJQ.helpers.dateHelpers.getDateString(this.completeDateInput.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE) : '',
            square_feet: square_feet,
            phone: '',
            flagColor: '',
            office_id: office_id,
            project_stage_id: project_stage_id,
            program_id: program_id,
            project_type_id: project_type_id,
            project_template_id: project_template_id,
            pantera_project_id: PJQ.app.session.project.id,
            documentListDrawings: drawings.join(','),
            documentListPublic: attachments.join(','),
            documentListPrivate: '',
            isSyncProjectContactVendors: this.$('.procore-sync-contacts').is(':checked')
        };


        new PJQ.ajax.Request({
            endpoint: '/procore/projects',
            data: postData
        }).post().done(_.bind(function (data) {
            if (data != '0') {
                PJQ.app.session.project.set('externalProjectId', 'PROCORE:' + data);
                PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id, {
                    trigger: true
                });
                this.removeModal();
                new PJQ.views.BaseModal({
                    header: "Procore Project",
                    body: '<a href="https://api.procore.com/' + data + '/project/home" target="_blank">Click here</a> to open your Procore project in a new window.  If Drawings or Attachments were selected, it may take some time for uploading to complete.'
                });

            }
            else {
                new PJQ.views.BaseModal({
                    header: "Procore Publish Error",
                    body: 'Unable to create/locate Procore Project. Error 124'
                });
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            new PJQ.views.BaseModal({
                header: "Procore Publish Error",
                body: (xhr.responseJSON.exceptionMessage ? xhr.responseJSON.exceptionMessage : 'Unknown error')
            });
        }, this));



    }
});
